@if (logoURL$ | async) {
  <div class="w-fit">
    <div class="bg-[#f8f8f8] p-6 rounded relative w-full">
      @if (isCreationProcess$ | async) {
        <div class="upper-arrow"></div>
      } @else {
        <div class="font-bold text-lg">
          {{ 'assets.app-logo' | translate }}
        </div>
        <div class="mb-4">{{ 'assets.app-logo-explained' | translate }}</div>
      }
      <div
        [class.two-logos-container]="availableOnAndroidTV$ | async"
        [style.gap.px]="assetGroupGap"
      >
        <!-- Logo icon -->
        <div
          class="flex flex-col gap-5 app-logo-asset asset-display-container"
          [style.width.px]="assetWidth"
        >
          <rk-asset-display
            [imageUrl]="logoURL$ | async"
            assetKey="logo"
            (crop)="onCrop($event)"
            (replace)="onReplace('logo')"
          ></rk-asset-display>
          <div>
            <div class="font-bold mb-1">
              {{ 'assets.logo' | translate }}
            </div>
            <div class="opacity-70 text-sm">
              {{ 'assets.logo-description' | translate }}
            </div>
          </div>
          <rk-infobox [type]="'info'" class="w-fit">
            <div class="font-bold text-sm">
              <fa-icon [icon]="'info-circle'"></fa-icon>
              {{ 'assets.restrictions' | translate }}
            </div>
            <div [innerHTML]="'assets.constraints-icon-smartphone' | translate"></div>
          </rk-infobox>
        </div>
        <!-- Tv icon -->

        @if (availableOnAndroidTV$ | async) {
          <div
            class="flex flex-col gap-5 asset-display-container"
            [style.width.px]="assetWidth"
          >
            <rk-asset-display
              [imageUrl]="iconTvURL$ | async"
              assetKey="iconTv"
              (crop)="onCrop($event)"
              (replace)="onReplace('iconTv')"
            ></rk-asset-display>
            <div>
              <div class="font-bold mb-1">
                {{ 'assets.icon-tv' | translate }}
              </div>
              <div class="opacity-70 text-sm">
                {{ 'assets.icon-tv-description' | translate }}
              </div>
            </div>
            <rk-infobox [type]="'info'" class="w-fit">
              <div class="font-bold text-sm">
                <fa-icon [icon]="'info-circle'"></fa-icon>
                {{ 'assets.restrictions' | translate }}
              </div>
              <div [innerHTML]="'assets.constraints-icon-tv' | translate"></div>
              <p><br />{{ 'assets.restrictions-icon-tv' | translate }}</p>
            </rk-infobox>
          </div>
        }
      </div>
    </div>
  </div>
}
